import React from 'react';
import PropTypes from 'prop-types';
import Component from 'components/component';

export default class AccountBlock extends Component {

    static propTypes = {
        type: PropTypes.string,
        title: PropTypes.string
    };

    static defaultProps = {
        left: true,
        right: true
    };

    render() {
        return (
            <div className="account-block">
                <div className="account-block-inner">
                    {this.props.type && (
                        <span className="account-block-user__type">
                            {this.props.type}
                        </span>
                    )}
                    {this.props.left && (
                        <div className="account-block-left">
                            <span className="account-block__title">
                                {this.props.title}
                            </span>
                            {this.props.text && (
                                <span className="account-block__text _vis">{this.props.text}</span>
                            )}
                        </div>
                    )}
                    {this.props.right && (
                        <div className="account-block-right">
                            {this.props.children}
                        </div>
                    )}
                    {(!this.props.left && !this.props.right) && (
                        this.props.children
                    )}
                    
                </div>
            </div>
        );
    }
}

export const AccountBlockFields = (props) => <div {...props} className={Component.classList("account-block-fields", props.className)}/>
export const AccountBlockButtons = (props) => <div {...props} className={Component.classList("account-block-buttons", props.className)}/>
export const AccountBlockHR = (props) => <div {...props} className={Component.classList("account-block__hr", props.className)}/>